(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-overlay]');
  const allDrawers = () => [...document.querySelectorAll('[data-drawer]')];
  let drawerOpener = null;
  const close = (restoreFocus = true) => {
    const wasOpen = allDrawers().some((drawer) => drawer.classList.contains('is-open'));
    allDrawers().forEach((drawer) => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true; });
    if (overlay) overlay.hidden = true;
    body.classList.remove('drawer-open');
    document.querySelectorAll('[data-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (restoreFocus && wasOpen && drawerOpener?.isConnected) drawerOpener.focus();
    if (restoreFocus) drawerOpener = null;
  };
  const openDrawer = (name, opener = null) => {
    close(false);
    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    drawerOpener = opener || document.activeElement;
    opener?.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.hidden = false;
    body.classList.add('drawer-open');
    drawer.querySelector(name === 'search' ? 'input[type="search"]' : 'button, input, a')?.focus();
  };
  const initializeDrawerState = () => allDrawers().forEach((drawer) => { drawer.inert = !drawer.classList.contains('is-open'); });
  initializeDrawerState();
  document.addEventListener('shopify:section:load', initializeDrawerState);
  document.addEventListener('shopify:section:unload', (event) => { if (event.target.querySelector('[data-drawer].is-open')) close(); });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const drawer = allDrawers().find((item) => item.classList.contains('is-open'));
    if (!drawer) return;
    const controls = [...drawer.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]')].filter((item) => !item.disabled && item.tabIndex >= 0 && item.getClientRects().length && !item.closest('[hidden],[inert]'));
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  });
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      openDrawer(opener.dataset.drawerOpen, opener);
      return;
    }
    if (event.target.closest('[data-drawer-close]') || event.target === overlay) close();
    const galleryArrow = event.target.closest('[data-product-gallery-direction]');
    if (galleryArrow) {
      const gallery = galleryArrow.closest('.replica-product-gallery');
      const thumbs = gallery ? [...gallery.querySelectorAll('.replica-product-thumb[data-product-thumb]')] : [];
      if (thumbs.length) {
        const activeIndex = Math.max(0, thumbs.findIndex((item) => item.classList.contains('is-active')));
        const increment = galleryArrow.dataset.productGalleryDirection === 'previous' ? -1 : 1;
        const nextIndex = Math.min(thumbs.length - 1, Math.max(0, activeIndex + increment));
        thumbs[nextIndex].click();
      }
    }
    const thumb = event.target.closest('.replica-product-thumb[data-product-thumb]');
    if (thumb) {
      const gallery = thumb.closest('.replica-product-gallery');
      if (gallery) {
        gallery.querySelectorAll('.replica-product-thumb').forEach((item) => item.classList.toggle('is-active', item === thumb));
        const slides = [...gallery.querySelectorAll('.product__media-item')];
        const matched = slides.find((slide) => slide.querySelector('[data-product-thumb]')?.dataset.productThumb === thumb.dataset.productThumb);
        slides.forEach((slide) => {
          slide.classList.toggle('is-active', slide === matched);
          if (slide !== matched) {
            slide.querySelectorAll('[data-native-media-player]').forEach((player) => {
              player.querySelector('video')?.pause();
              player.remove();
            });
            const preview = slide.querySelector('[data-native-media-play]');
            if (preview) preview.hidden = false;
          }
        });
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (matched && window.matchMedia('(max-width: 749px)').matches) {
          const mediaList = gallery.querySelector('[data-product-gallery]');
          mediaList?.scrollTo({ left: Math.max(0, matched.offsetLeft - (mediaList.clientWidth - matched.clientWidth) / 2), behavior: 'smooth' });
        }
      }
    }
    const partner = event.target.closest('[data-replica-partners] .replica-partner-slide');
    if (partner) {
      partner.closest('[data-replica-partners]').querySelectorAll('.replica-partner-slide').forEach((item) => item.classList.toggle('is-active', item === partner));
      partner.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    const flavor = event.target.closest('.replica-flavor-swatches .sb-flavor-swatch');
    if (flavor) flavor.parentElement.querySelectorAll('.sb-flavor-swatch').forEach((item) => item.classList.toggle('is-active', item === flavor));
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  document.querySelectorAll('.tl-nav details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) document.querySelectorAll('.tl-nav details').forEach((other) => { if (other !== details) other.open = false; });
    });
  });
  const collectMegaMenus = (root = document) => {
    const menus = [];
    if (root?.matches?.('.sb-mega-menu')) menus.push(root);
    root?.querySelectorAll?.('.sb-mega-menu').forEach((menu) => menus.push(menu));
    return menus;
  };
  const setMegaMenuOpen = (menu, open, { restoreFocus = false } = {}) => {
    const summary = menu.querySelector(':scope > summary');
    menu.open = open;
    menu.classList.toggle('sb-open', open);
    summary?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (restoreFocus) summary?.focus();
  };
  const cleanupMegaMenu = (menu) => {
    menu.replicaMegaMenuController?.abort();
    menu.replicaMegaMenuController = null;
  };
  const initializeMegaMenu = (menu) => {
    cleanupMegaMenu(menu);
    const summary = menu.querySelector(':scope > summary');
    if (!summary) return;
    const controller = new AbortController();
    const { signal } = controller;
    const desktopHover = window.matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');
    let suppressFocusOpen = false;
    menu.replicaMegaMenuController = controller;

    const closeOtherMenus = () => {
      menu.closest('.sb-header__inline-menu')?.querySelectorAll('.sb-mega-menu').forEach((other) => {
        if (other !== menu) setMegaMenuOpen(other, false);
      });
    };
    const openMenu = () => {
      closeOtherMenus();
      setMegaMenuOpen(menu, true);
    };
    const closeMenu = () => setMegaMenuOpen(menu, false);

    summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    menu.addEventListener('mouseenter', () => { if (desktopHover.matches) openMenu(); }, { signal });
    menu.addEventListener('mouseleave', () => { if (desktopHover.matches) closeMenu(); }, { signal });
    menu.addEventListener('focusin', () => requestAnimationFrame(() => {
      if (!suppressFocusOpen && menu.contains(document.activeElement)) openMenu();
    }), { signal });
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) closeMenu();
    }, { signal });
    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      suppressFocusOpen = true;
      setMegaMenuOpen(menu, false, { restoreFocus: true });
      requestAnimationFrame(() => { suppressFocusOpen = false; });
    }, { signal });
    menu.addEventListener('toggle', () => {
      if (menu.open) closeOtherMenus();
      menu.classList.toggle('sb-open', menu.open);
      summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    }, { signal });
    desktopHover.addEventListener?.('change', (event) => {
      if (!event.matches) closeMenu();
    }, { signal });
  };
  const initializeMegaMenus = (root = document) => collectMegaMenus(root).forEach(initializeMegaMenu);
  initializeMegaMenus(document);
  document.addEventListener('shopify:section:load', (event) => initializeMegaMenus(event.target));
  document.addEventListener('shopify:section:unload', (event) => collectMegaMenus(event.target).forEach(cleanupMegaMenu));
  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-sort]');
    if (select) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
      return;
    }
    const input = event.target.closest('[data-filter-form] input[type="checkbox"]');
    input?.form?.requestSubmit();
  });
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-filter-toggle]');
    if (filterButton) {
      const wrapper = filterButton.closest('.sb-facets-vertical')?.querySelector('.facets-wrapper');
      if (wrapper) {
        const open = wrapper.classList.toggle('is-open');
        filterButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) wrapper.querySelector('input, select, button, summary')?.focus();
      }
    }
    const button = event.target.closest('[data-tab-button]');
    const section = button?.closest('[data-replica-tabs]');
    if (!section) return;
    section.querySelectorAll('[data-tab-button]').forEach((item) => { const active = item === button; item.dataset.tabActive = active ? 'true' : 'false'; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', active ? 'true' : 'false'); });
    section.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      const active = panel.dataset.tabPanel === button.dataset.tabButton;
      panel.hidden = !active;
      panel.dataset.tabActive = active ? 'true' : 'false';
      if (active) requestAnimationFrame(() => panel.querySelectorAll('[data-replica-rail]').forEach((rail) => rail.replicaRefresh?.({ reset: true })));
    });
  });
  const equalizeCompactCollectionTitles = () => {
    document.querySelectorAll('.tl-source-tl-collection-grid .sb-product-grid').forEach((grid) => {
      const items = [...grid.querySelectorAll(':scope > .sb-product-grid__item')];
      items.forEach((item) => item.querySelector('.sb-product-card__title')?.style.removeProperty('--replica-card-title-height'));
      if (!window.matchMedia('(max-width: 1024px)').matches) return;
      const rows = new Map();
      items.forEach((item) => {
        const rowKey = Math.round(item.offsetTop);
        if (!rows.has(rowKey)) rows.set(rowKey, []);
        rows.get(rowKey).push(item);
      });
      rows.forEach((row) => {
        const maxTitleHeight = Math.max(...row.map((item) => item.querySelector('.sb-product-card__title')?.getBoundingClientRect().height || 0));
        row.forEach((item) => item.querySelector('.sb-product-card__title')?.style.setProperty('--replica-card-title-height', `${maxTitleHeight}px`));
      });
    });
  };
  const normalizeCompactBlogRails = () => {
    document.querySelectorAll('.template-collection .replica-blog-rail, .template-index .replica-blog-rail').forEach((rail) => {
      rail.style.removeProperty('--replica-blog-rail-height');
      const isCompactCollection = rail.closest('.template-collection') && window.matchMedia('(max-width: 749px)').matches;
      const isCompactHome = rail.closest('.template-index') && window.matchMedia('(max-width: 768px)').matches;
      if (!isCompactCollection && !isCompactHome) return;
      const firstCard = rail.querySelector(':scope > .replica-blog-slide:first-child .sb-blog-card');
      const firstCardHeight = firstCard?.getBoundingClientRect().height || 0;
      if (firstCardHeight > 0) rail.style.setProperty('--replica-blog-rail-height', `${firstCardHeight}px`);
    });
  };
  let titleEqualizeFrame = 0;
  const scheduleCompactTitleEqualization = () => {
    if (titleEqualizeFrame) cancelAnimationFrame(titleEqualizeFrame);
    titleEqualizeFrame = requestAnimationFrame(() => {
      titleEqualizeFrame = 0;
      equalizeCompactCollectionTitles();
      normalizeCompactBlogRails();
    });
  };
  scheduleCompactTitleEqualization();
  document.fonts?.ready.then(scheduleCompactTitleEqualization);
  window.addEventListener('resize', scheduleCompactTitleEqualization, { passive: true });
  document.addEventListener('shopify:section:load', scheduleCompactTitleEqualization);
  const initializeReplicaRail = (rail) => {
    rail.replicaController?.abort();
    rail.replicaController = new AbortController();
    const { signal } = rail.replicaController;
    const scope = rail.closest('[data-tab-panel], .sb-featured-reviews__slider, [data-replica-partners], .sb-featured-blog, section');
    const paginationWrapper = scope?.querySelector('.sb-pagination-wrapper');
    const pagination = paginationWrapper?.querySelector('.replica-pagination');
    const current = paginationWrapper?.querySelector('.sb-swiper-pagination-current');
    const total = paginationWrapper?.querySelector('.sb-swiper-pagination-total');
    if (!paginationWrapper || !pagination || !current || !total) return;

    let snapOffsets = [0];
    let scrollFrame = 0;
    const formatCount = (value) => String(value).padStart(2, '0');
    const updateActiveSnap = () => {
      scrollFrame = 0;
      const activeIndex = snapOffsets.reduce((nearest, offset, index) => (
        Math.abs(offset - rail.scrollLeft) < Math.abs(snapOffsets[nearest] - rail.scrollLeft) ? index : nearest
      ), 0);
      pagination.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
        const active = index === activeIndex;
        bullet.classList.toggle('swiper-pagination-bullet-active', active);
        if (active) bullet.setAttribute('aria-current', 'true');
        else bullet.removeAttribute('aria-current');
      });
      if (scope?.matches?.('[data-replica-partners]')) {
        [...rail.children].forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      }
      current.textContent = formatCount(activeIndex + 1);
    };
    const buildBullets = () => {
      if (pagination.children.length === snapOffsets.length) return;
      const bullets = snapOffsets.map((_, index) => {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('tabindex', '0');
        bullet.setAttribute('aria-label', `Go to slide ${index + 1} of ${snapOffsets.length}`);
        const activate = () => rail.scrollTo({ left: snapOffsets[index], behavior: 'smooth' });
        bullet.addEventListener('click', activate);
        bullet.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate();
          }
        });
        return bullet;
      });
      pagination.replaceChildren(...bullets);
    };
    const refresh = ({ reset = false } = {}) => {
      if (rail.clientWidth === 0) return;
      const railRect = rail.getBoundingClientRect();
      const paddingLeft = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const offsets = [...rail.children].map((child) => {
        const rawOffset = child.getBoundingClientRect().left - railRect.left + rail.scrollLeft - paddingLeft;
        return Math.min(maxScroll, Math.max(0, rawOffset));
      });
      snapOffsets = offsets.filter((offset, index) => index === 0 || Math.abs(offset - offsets[index - 1]) > 1);
      if (!snapOffsets.length) snapOffsets = [0];
      paginationWrapper.removeAttribute('aria-hidden');
      paginationWrapper.setAttribute('aria-label', 'Carousel pagination');
      pagination.setAttribute('role', 'group');
      total.textContent = formatCount(snapOffsets.length);
      buildBullets();
      if (reset) rail.scrollTo({ left: 0, behavior: 'auto' });
      else if (rail.scrollLeft > maxScroll) rail.scrollLeft = maxScroll;
      updateActiveSnap();
    };

    rail.replicaRefresh = refresh;
    rail.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateActiveSnap);
    }, { passive: true, signal });
    window.addEventListener('resize', () => requestAnimationFrame(() => { if (rail.isConnected) refresh(); }), { passive: true, signal });
    signal.addEventListener('abort', () => cancelAnimationFrame(scrollFrame), { once: true });
    requestAnimationFrame(() => refresh({ reset: !rail.closest('[hidden]') }));
  };
  const collectReplicaRails = (root = document) => [
    ...(root.matches?.('[data-replica-rail]') ? [root] : []),
    ...root.querySelectorAll('[data-replica-rail]')
  ];
  collectReplicaRails().forEach(initializeReplicaRail);
  document.addEventListener('shopify:section:load', (event) => collectReplicaRails(event.target).forEach(initializeReplicaRail));
  document.addEventListener('shopify:section:unload', (event) => collectReplicaRails(event.target).forEach((rail) => { rail.replicaController?.abort(); delete rail.replicaRefresh; }));
  const loadNextPage = async (pagination) => {
    if (pagination.dataset.loading === 'true') return;
    const trigger = pagination.querySelector('[data-infinite-scroll]');
    const button = pagination.querySelector('[data-load-more]');
    const nextUrl = trigger?.dataset.paginationNext || button?.href;
    if (!nextUrl) return;
    pagination.dataset.loading = 'true';
    try {
      const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
      const currentGrid = pagination.closest('section, .sb-collection-products, .tl-collection-layout')?.querySelector('[data-product-grid]');
      const nextGrid = documentNext.querySelector('[data-product-grid]');
      if (currentGrid && nextGrid) currentGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
      scheduleCompactTitleEqualization();
      const nextTrigger = documentNext.querySelector('[data-infinite-scroll]');
      const nextButton = documentNext.querySelector('[data-load-more]');
      const updatedUrl = nextTrigger?.dataset.paginationNext || nextButton?.href;
      if (trigger) trigger.dataset.paginationNext = updatedUrl || '';
      if (button) { if (updatedUrl) button.href = updatedUrl; else button.remove(); }
      if (!updatedUrl) pagination.remove();
    } finally { pagination.dataset.loading = 'false'; }
  };
  document.querySelectorAll('[data-pagination]').forEach((pagination) => {
    pagination.querySelector('[data-load-more]')?.addEventListener('click', (event) => { event.preventDefault(); loadNextPage(pagination); });
    if (pagination.dataset.paginationType === 'infinite_scroll') {
      const trigger = pagination.querySelector('[data-infinite-scroll]');
      if (trigger && 'IntersectionObserver' in window) new IntersectionObserver((entries) => { if (entries.some((entry) => entry.isIntersecting)) loadNextPage(pagination); }, { rootMargin: '500px' }).observe(trigger);
    }
  });
  const nutritionPanels = (root = document) => {
    const panels = [];
    if (root?.matches?.('[data-product-nutrition]')) panels.push(root);
    root?.querySelectorAll?.('[data-product-nutrition]').forEach((panel) => panels.push(panel));
    return panels;
  };
  const syncProductNutrition = ({ productId, variantId }, root = document) => {
    nutritionPanels(root).forEach((panel) => {
      if (String(panel.dataset.productId || '') !== String(productId || '')) return;
      const image = panel.querySelector('[data-product-nutrition-image]');
      const mapNode = panel.querySelector('[data-product-nutrition-variants]');
      if (!image || !mapNode) return;
      let nutritionMap = {};
      try { nutritionMap = JSON.parse(mapNode.textContent); } catch (_) { return; }
      const source = variantId == null || variantId === ''
        ? ''
        : (nutritionMap.variants?.[String(variantId)] || nutritionMap.default || '');
      const imageWrapper = image.closest('.sb-product-detail__nutrition-image');
      image.hidden = !source;
      if (imageWrapper) imageWrapper.hidden = !source;
      if (!source) {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        return;
      }
      image.src = source;
      image.removeAttribute('srcset');
      image.alt = nutritionMap.alt || image.alt || 'Nutrition & Supplement Facts';
      panel.dataset.selectedVariant = String(variantId);
    });
  };
  const initializeProductNutrition = (root = document) => nutritionPanels(root).forEach((panel) => {
    syncProductNutrition({ productId: panel.dataset.productId, variantId: panel.dataset.selectedVariant }, panel);
  });
  initializeProductNutrition(document);
  document.addEventListener('replica:variant-change', (event) => syncProductNutrition(event.detail || {}));
  document.addEventListener('shopify:section:load', (event) => initializeProductNutrition(event.target));
  const collectProductInfos = (root = document) => {
    const productInfos = [];
    if (root?.matches?.('[data-product-info]')) productInfos.push(root);
    root?.querySelectorAll?.('[data-product-info]').forEach((productInfo) => productInfos.push(productInfo));
    return productInfos;
  };

  const cleanupProductInfo = (productInfo) => {
    productInfo.replicaProductController?.abort();
    productInfo.replicaProductObserver?.disconnect();
    productInfo.replicaProductController = null;
    productInfo.replicaProductObserver = null;
    productInfo.replicaStickyResizeObserver?.disconnect();
    productInfo.replicaStickyResizeObserver = null;
    document.body.classList.remove('fn-sticky-visible');
    document.body.style.removeProperty('--fn-sticky-height');
  };

  const initializeProductInfo = (productInfo) => {
    cleanupProductInfo(productInfo);
    const form = productInfo.querySelector('form[action*="/cart/add"]');
    const variantData = productInfo.querySelector('[data-product-variants]');
    const variantInput = productInfo.querySelector('[data-product-variant-id]');
    let sellingPlanInput = productInfo.querySelector('[data-product-selling-plan-input]');
    const quantityInput = productInfo.querySelector('[data-product-quantity]');
    const stickyQuantityInput = productInfo.querySelector('[data-sticky-quantity]');
    const defaultStickyImage = productInfo.querySelector('[data-sticky-product-media] img')?.getAttribute('src') || '';
    if (!form || !variantData || !variantInput) return;
    const productRoot = productInfo.closest('product-info');
    const productId = productInfo.dataset.productId || productRoot?.dataset.productId || '';
    const shouldUpdateProductUrl = (productInfo.dataset.updateUrl || productRoot?.dataset.updateUrl) === 'true';
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (_) { return; }
    const controller = new AbortController();
    const { signal } = controller;
    productInfo.replicaProductController = controller;

    const ensureSellingPlanInput = () => {
      const currentInput = form.querySelector('[data-product-selling-plan-input]');
      if (currentInput) {
        sellingPlanInput = currentInput;
        return currentInput;
      }
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.setAttribute('data-product-selling-plan-input', '');
      const activePurchaseGroup = productInfo.querySelector('[data-selling-plans-for]:not([hidden])');
      const activePurchaseOption = activePurchaseGroup?.querySelector('input[name="purchase_type"]:checked');
      const activePlanSelect = activePurchaseGroup?.querySelector('select[name="selling_plan"], [data-selling-plan-select]');
      const subscriptionActive = activePurchaseOption?.value === 'subscription' && Boolean(activePlanSelect?.value);
      input.value = subscriptionActive ? String(activePlanSelect.value) : '';
      input.disabled = !subscriptionActive;
      form.append(input);
      sellingPlanInput = input;
      return input;
    };

    const suppressSubscriptionAppUi = productInfo.dataset.suppressSubscriptionAppUi === 'true';
    const suppressInjectedSubscriptionUi = () => {
      if (!suppressSubscriptionAppUi) return;
      form.querySelectorAll('.sealsubs-target-element').forEach((element) => {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.querySelectorAll('input, select, button, textarea').forEach((control) => { control.disabled = true; });
      });
      ensureSellingPlanInput();
    };
    suppressInjectedSubscriptionUi();
    if (typeof MutationObserver !== 'undefined') {
      const subscriptionObserver = new MutationObserver(suppressInjectedSubscriptionUi);
      subscriptionObserver.observe(form, { childList: true, subtree: true });
      signal.addEventListener('abort', () => subscriptionObserver.disconnect(), { once: true });
    }

    const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(Number(cents || 0) / 100);
    let activeVariant = variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0] || null;
    const announceVariant = (variant) => document.dispatchEvent(new CustomEvent('replica:variant-change', {
      detail: { productId, variantId: variant?.id ?? '' }
    }));
    const sellingPlanGroups = () => [...productInfo.querySelectorAll('[data-selling-plans-for]')];
    const productOptionGroups = () => [...productInfo.querySelectorAll('[data-product-option-position]')];
    let preferredPurchaseType = 'one_time';
    let preferredSellingPlanId = '';
    let preferredSellingPlanName = '';

    const rememberPurchaseState = () => {
      const group = sellingPlanGroups().find((candidate) => !candidate.hidden);
      if (!group) return;
      const purchaseOption = group.querySelector('input[name="purchase_type"]:checked') || group.querySelector('[data-purchase-option]:checked');
      if (purchaseOption?.value) preferredPurchaseType = purchaseOption.value;
      if (preferredPurchaseType !== 'subscription') return;
      const planSelect = group.querySelector('select[name="selling_plan"]') || group.querySelector('[data-selling-plan-select]');
      const selectedPlan = planSelect?.selectedOptions?.[0] || planSelect?.options?.[planSelect.selectedIndex] || null;
      if (!selectedPlan) return;
      preferredSellingPlanId = String(selectedPlan.value || '');
      preferredSellingPlanName = String(selectedPlan.dataset.planName || selectedPlan.textContent || '');
    };

    const selectPreferredPlan = (planSelect) => {
      const options = [...(planSelect?.options || [])];
      if (!options.length) return null;
      const selectedPlan = options.find((option) => preferredSellingPlanId && String(option.value) === preferredSellingPlanId)
        || options.find((option) => preferredSellingPlanName && String(option.dataset.planName || option.textContent || '') === preferredSellingPlanName)
        || options[0];
      options.forEach((option) => { option.selected = option === selectedPlan; });
      planSelect.selectedIndex = options.indexOf(selectedPlan);
      planSelect.value = selectedPlan.value;
      return selectedPlan;
    };

    const selectedOptionValues = () => productOptionGroups().map((group) => (
      group.querySelector('[data-product-option]:checked')?.value || ''
    ));

    const applyVariantSelection = (optionValues) => productOptionGroups().forEach((group, index) => {
      group.querySelectorAll('[data-product-option]').forEach((input) => {
        input.checked = input.value === optionValues[index];
      });
      const selectedLabel = group.querySelector('[data-selected-option]');
      if (selectedLabel) selectedLabel.textContent = optionValues[index] || '';
    });

    const syncOptionAvailability = (optionValues) => productOptionGroups().forEach((group, index) => {
      group.querySelectorAll('[data-product-option]').forEach((input) => {
        const combinationExists = variants.some((variant) => (
          variant.options[index] === input.value
          && variant.options.slice(0, index).every((option, priorIndex) => option === optionValues[priorIndex])
        ));
        const combinationAvailable = variants.some((variant) => (
          variant.available
          && variant.options[index] === input.value
          && variant.options.slice(0, index).every((option, priorIndex) => option === optionValues[priorIndex])
        ));
        input.disabled = !combinationExists;
        input.setAttribute('aria-disabled', String(!combinationExists));
        const label = input.nextElementSibling;
        if (label?.tagName === 'LABEL') {
          // Hide values that do not exist for the earlier choices; keep sold-out values selectable.
          label.classList.toggle('is-missing', !combinationExists);
          label.classList.toggle('is-sold-out', combinationExists && !combinationAvailable);
        }
      });
    });

    rememberPurchaseState();

    const setPricePair = (currentNode, compareNode, price, compareAtPrice) => {
      if (currentNode) currentNode.textContent = formatMoney(price);
      if (!compareNode) return;
      const showCompare = Number(compareAtPrice || 0) > Number(price || 0);
      compareNode.hidden = !showCompare;
      compareNode.textContent = showCompare ? formatMoney(compareAtPrice) : '';
    };

    const syncPurchaseState = (group, variant = activeVariant) => {
      if (!group || !variant || group.hidden) return;
      const purchaseOption = group.querySelector('input[name="purchase_type"]:checked') || group.querySelector('[data-purchase-option]:checked');
      const planSelect = group.querySelector('select[name="selling_plan"]') || group.querySelector('[data-selling-plan-select]');
      const subscriptionSelected = purchaseOption?.value === 'subscription' || purchaseOption?.dataset.purchaseOption === 'subscription';
      const selectedPlan = planSelect?.selectedOptions?.[0] || planSelect?.options?.[planSelect.selectedIndex] || null;
      const subscriptionActive = Boolean(subscriptionSelected && selectedPlan);
      if (planSelect) planSelect.disabled = !subscriptionActive;

      const price = subscriptionActive ? Number(selectedPlan.dataset.price || variant.price) : Number(variant.price || 0);
      const compareAtPrice = subscriptionActive
        ? Number(selectedPlan.dataset.comparePrice || variant.price || 0)
        : Number(variant.compare_at_price || 0);
      const savings = subscriptionActive ? Number(selectedPlan.dataset.savings || Math.max(0, compareAtPrice - price)) : 0;
      const planName = subscriptionActive ? (selectedPlan.dataset.planName || selectedPlan.textContent || '') : '';

      setPricePair(
        productInfo.querySelector('[data-product-price-current]'),
        productInfo.querySelector('[data-product-price-compare]'),
        price,
        compareAtPrice
      );
      const stickyPrice = productInfo.querySelector('[data-sticky-price]');
      const stickyCompare = productInfo.querySelector('[data-sticky-compare]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      if (stickyCompare) {
        const showStickyCompare = Number(compareAtPrice || 0) > Number(price || 0);
        stickyCompare.hidden = !showStickyCompare;
        stickyCompare.textContent = showStickyCompare ? formatMoney(compareAtPrice) : '';
      }

      const subscriptionPrice = group.querySelector('[data-subscription-price]');
      const subscriptionCompare = group.querySelector('[data-subscription-compare]');
      if (selectedPlan) setPricePair(subscriptionPrice, subscriptionCompare, selectedPlan.dataset.price, selectedPlan.dataset.comparePrice);
      const savingsLabel = group.querySelector('[data-subscription-savings]');
      if (savingsLabel) savingsLabel.textContent = savings > 0 ? `${formatMoney(savings)} off` : '';
      const recurringNote = group.querySelector('[data-subscription-recurring]');
      if (recurringNote) {
        const recurringPrice = selectedPlan ? Number(selectedPlan.dataset.recurringPrice || selectedPlan.dataset.price || 0) : 0;
        const showRecurring = Boolean(selectedPlan) && recurringPrice > 0 && recurringPrice !== Number(selectedPlan.dataset.price || 0);
        recurringNote.hidden = !showRecurring;
        recurringNote.textContent = showRecurring ? `Then ${formatMoney(recurringPrice)} per delivery after your first order` : '';
      }
      const savingsBenefit = group.querySelector('[data-subscription-savings-benefit]');
      if (savingsBenefit) {
        savingsBenefit.hidden = savings <= 0;
        savingsBenefit.textContent = savings > 0 ? `Save ${formatMoney(savings)} today` : '';
      }

      const stickyPurchaseType = productInfo.querySelector('[data-sticky-purchase-type]');
      const stickyCadence = productInfo.querySelector('[data-sticky-cadence]');
      const stickyBenefits = productInfo.querySelector('[data-sticky-benefits]');
      const planSavings = selectedPlan ? Math.max(0, Number(selectedPlan.dataset.comparePrice || variant.price) - Number(selectedPlan.dataset.price || variant.price)) : 0;
      productInfo.querySelectorAll('[data-sticky-onetime-price]').forEach(node => { node.textContent = formatMoney(variant.price); });
      setPricePair(productInfo.querySelector('[data-sticky-subscription-price]'), productInfo.querySelector('[data-sticky-subscription-compare]'), selectedPlan?.dataset.price || variant.price, selectedPlan?.dataset.comparePrice || variant.compare_at_price);
      const stickyDetails = productInfo.querySelector('[data-sticky-purchase-summary]');
      stickyDetails?.classList.toggle('r-sticky-details--onetime', !subscriptionActive);
      if (stickyPurchaseType) stickyPurchaseType.textContent = subscriptionActive ? (stickyPurchaseType.dataset.subscriptionLabel || 'Subscribe and') : (purchaseOption?.dataset.purchaseLabel || 'One-Time Purchase');
      if (stickyCadence) {
        stickyCadence.hidden = !subscriptionActive;
        stickyCadence.textContent = planName;
      }
      if (stickyBenefits) stickyBenefits.hidden = !subscriptionActive;
      productInfo.querySelectorAll('[data-sticky-savings], [data-sticky-savings-badge]').forEach((node) => {
        const isBadge = node.hasAttribute('data-sticky-savings-badge');
        const amount = isBadge ? planSavings : savings;
        node.hidden = amount <= 0 || (isBadge && node.closest('.r-sticky-selected') && !subscriptionActive);
        node.textContent = amount > 0 ? (isBadge ? `Save ${formatMoney(amount)}` : `Save ${formatMoney(amount)} today`) : '';
      });

      const stickyChoiceButtons = productInfo.querySelectorAll('[data-sticky-purchase-option]');
      if (stickyChoiceButtons.length) {
        const subscriptionChoice = group.querySelector('input[name="purchase_type"][value="subscription"]');
        const canSubscribe = Boolean(subscriptionChoice && planSelect && planSelect.options?.length);
        stickyChoiceButtons.forEach((button) => {
          const isSubscriptionChoice = button.dataset.stickyPurchaseOption === 'subscription';
          const isActiveChoice = isSubscriptionChoice ? subscriptionActive : !subscriptionActive;
          if (isSubscriptionChoice) {
            button.hidden = !canSubscribe;
            button.disabled = !canSubscribe;
          }
          const row = button.closest('[data-sticky-choice-row]');
          row?.classList.toggle('r-sf-active', isActiveChoice);
          if (isSubscriptionChoice && row) row.hidden = !canSubscribe;
          button.classList.toggle('is-active', isActiveChoice);
          button.setAttribute('aria-pressed', String(isActiveChoice));
        });
      }

      const stickyPlanSelect = productInfo.querySelector('[data-sticky-selling-plan-select]');
      const stickyFrequencyWrap = productInfo.querySelector('[data-sticky-frequency-wrap]');
      if (stickyPlanSelect && planSelect) {
        const mainOptions = [...(planSelect.options || [])];
        const stickyOptions = [...(stickyPlanSelect.options || [])];
        const needsRebuild = stickyOptions.length !== mainOptions.length
          || mainOptions.some((option, index) => String(stickyOptions[index]?.value || '') !== String(option.value || ''));
        if (needsRebuild) {
          stickyPlanSelect.innerHTML = '';
          mainOptions.forEach((option) => {
            const stickyOption = document.createElement('option');
            stickyOption.value = option.value;
            stickyOption.textContent = String(option.dataset.planName || option.textContent).replace(/ subscription/ig, '').replace(/ day(?!s)/ig, ' days');
            stickyOption.dataset.price = option.dataset.price || '';
            stickyOption.dataset.comparePrice = option.dataset.comparePrice || '';
            stickyOption.dataset.planName = option.dataset.planName || option.textContent || '';
            stickyPlanSelect.append(stickyOption);
          });
        }
        if (planSelect.value) stickyPlanSelect.value = planSelect.value;
        if (stickyFrequencyWrap) stickyFrequencyWrap.hidden = !subscriptionActive;
        stickyPlanSelect.disabled = !subscriptionActive;
      }

      group.dataset.purchaseType = subscriptionActive ? 'subscription' : 'one_time';
      productInfo.dataset.purchaseType = group.dataset.purchaseType;
      productInfo.dataset.sellingPlan = subscriptionActive ? String(planSelect.value || '') : '';
      const authoritativeSellingPlanInput = ensureSellingPlanInput();
      authoritativeSellingPlanInput.value = subscriptionActive ? String(planSelect.value || '') : '';
      authoritativeSellingPlanInput.disabled = !subscriptionActive;
    };

    const normalizeQuantity = () => {
      if (!quantityInput) return;
      const minimum = Number(quantityInput.min || 1);
      const increment = Math.max(1, Number(quantityInput.step || 1));
      const maximum = quantityInput.max === '' ? null : Number(quantityInput.max);
      const requested = Math.max(minimum, Number(quantityInput.value || minimum));
      const requestedSteps = Math.ceil((requested - minimum) / increment);
      const maximumSteps = maximum == null || Number.isNaN(maximum)
        ? requestedSteps
        : Math.max(0, Math.floor((maximum - minimum) / increment));
      quantityInput.value = String(minimum + (Math.min(requestedSteps, maximumSteps) * increment));
      if (stickyQuantityInput) {
        stickyQuantityInput.min = quantityInput.min;
        stickyQuantityInput.step = quantityInput.step;
        if (quantityInput.max === '') stickyQuantityInput.removeAttribute('max');
        else stickyQuantityInput.max = quantityInput.max;
        stickyQuantityInput.value = quantityInput.value;
      }
    };

    const updateVariant = (match, { updateUrl = true } = {}) => {
      rememberPurchaseState();
      const variantStatus = productInfo.querySelector('[data-product-variant-status]');
      if (!match) {
        activeVariant = null;
        productInfo.dataset.variantState = 'unavailable';
        variantInput.value = '';
        if (variantStatus) {
          variantStatus.hidden = false;
          variantStatus.textContent = 'This option combination is unavailable.';
        }
        const currentPrice = productInfo.querySelector('[data-product-price-current]');
        const comparePrice = productInfo.querySelector('[data-product-price-compare]');
        const stickyPrice = productInfo.querySelector('[data-sticky-price]');
        const stickyCompare = productInfo.querySelector('[data-sticky-compare]');
        if (currentPrice) currentPrice.textContent = 'Unavailable';
        if (comparePrice) {
          comparePrice.hidden = true;
          comparePrice.textContent = '';
        }
        if (stickyPrice) stickyPrice.textContent = 'Unavailable';
        if (stickyCompare) {
          stickyCompare.hidden = true;
          stickyCompare.textContent = '';
        }
        const stickyVariant = productInfo.querySelector('[data-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = 'Unavailable';
        const stickyImage = productInfo.querySelector('[data-sticky-product-media] img');
        if (stickyImage) {
          stickyImage.hidden = true;
          stickyImage.src = '';
          stickyImage.removeAttribute('srcset');
        }
        sellingPlanGroups().forEach((group) => {
          group.hidden = true;
          group.querySelectorAll('input[name="purchase_type"], select[name="selling_plan"]').forEach((input) => { input.disabled = true; });
        });
        productInfo.querySelectorAll('[data-main-add-to-cart], [data-sticky-add-to-cart]').forEach((button) => {
          button.dataset.variantAvailable = 'false';
          button.disabled = true;
          const unavailableLabel = button.dataset.unavailableLabel || 'Unavailable';
          const label = button.querySelector('span');
          if (label) label.textContent = unavailableLabel;
          else button.textContent = unavailableLabel;
        });
        announceVariant(null);
        return;
      }
      activeVariant = match;
      productInfo.dataset.variantState = match.available ? 'available' : 'sold_out';
      variantInput.value = String(match.id);
      if (variantStatus) {
        variantStatus.hidden = true;
        variantStatus.textContent = '';
      }
      applyVariantSelection(match.options);
      syncOptionAvailability(match.options);
      const stickyVariant = productInfo.querySelector('[data-sticky-variant]');
      if (stickyVariant) {
        const variantTitle = match.title || match.options?.join(' / ') || '';
        stickyVariant.textContent = variantTitle === 'Default Title' ? '' : variantTitle;
        stickyVariant.hidden = stickyVariant.textContent === '';
      }

      const quantityRule = match.quantity_rule || {};
      if (quantityInput) {
        const minimum = Number(quantityRule.min || 1);
        const increment = Number(quantityRule.increment || 1);
        const maximum = quantityRule.max == null ? null : Number(quantityRule.max);
        quantityInput.min = String(minimum);
        quantityInput.step = String(increment);
        if (maximum == null || Number.isNaN(maximum)) quantityInput.removeAttribute('max');
        else quantityInput.max = String(maximum);
        normalizeQuantity();
      }

      setPricePair(
        productInfo.querySelector('[data-product-price-current]'),
        productInfo.querySelector('[data-product-price-compare]'),
        match.price,
        match.compare_at_price
      );

      sellingPlanGroups().forEach((group) => {
        const active = group.dataset.sellingPlansFor === String(match.id);
        group.hidden = !active;
        const subscriptionOption = group.querySelector('input[name="purchase_type"][value="subscription"]') || group.querySelector('[data-purchase-option="subscription"]');
        const oneTimeOption = group.querySelector('input[name="purchase_type"][value="one_time"]') || group.querySelector('[data-purchase-option="one_time"], [data-purchase-option="one-time"]');
        const planSelect = group.querySelector('select[name="selling_plan"]') || group.querySelector('[data-selling-plan-select]');
        const canSubscribe = Boolean(subscriptionOption && planSelect && planSelect.options?.length);
        if (subscriptionOption) subscriptionOption.disabled = !active || !canSubscribe;
        if (oneTimeOption) oneTimeOption.disabled = !active;
        if (active) {
          const useSubscription = preferredPurchaseType === 'subscription' && canSubscribe;
          if (subscriptionOption) subscriptionOption.checked = useSubscription;
          if (oneTimeOption) oneTimeOption.checked = !useSubscription;
          if (useSubscription) selectPreferredPlan(planSelect);
          if (planSelect) planSelect.disabled = !useSubscription;
        } else if (planSelect) {
          planSelect.disabled = true;
        }
        if (active) syncPurchaseState(group, match);
      });

      productInfo.querySelectorAll('[data-main-add-to-cart], [data-sticky-add-to-cart]').forEach((button) => {
        button.dataset.variantAvailable = String(match.available);
        button.disabled = !match.available || form.dataset.cartSubmitting === 'true';
        const addLabel = match.available ? (button.dataset.availableLabel || 'Add To Cart') : 'Sold out';
        const label = button.querySelector('span');
        if (label) label.textContent = addLabel;
        else button.textContent = addLabel;
      });

      const featuredMediaId = match.featured_media?.id || match.featured_image?.id;
      if (featuredMediaId) {
        productInfo.closest('product-info')?.querySelector(`.replica-product-thumb[data-product-media="${featuredMediaId}"]`)?.click();
      }
      const stickyImage = productInfo.querySelector('[data-sticky-product-media] img');
      const featuredImageSource = match.featured_image?.src || match.featured_media?.preview_image?.src || defaultStickyImage;
      if (stickyImage && featuredImageSource) {
        stickyImage.hidden = false;
        stickyImage.src = featuredImageSource;
        stickyImage.removeAttribute('srcset');
      } else if (stickyImage) {
        stickyImage.hidden = true;
        stickyImage.src = '';
        stickyImage.removeAttribute('srcset');
      }

      if (updateUrl && shouldUpdateProductUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
      announceVariant(match);
    };

    productInfo.querySelectorAll('[data-product-option]').forEach((input) => input.addEventListener('change', () => {
      const changedGroup = input.closest('[data-product-option-position]');
      const changedIndex = Math.max(0, Number(changedGroup?.dataset.productOptionPosition || 1) - 1);
      const chosen = selectedOptionValues();
      let match = variants.find((variant) => variant.options.every((option, index) => option === chosen[index]));
      if (!match) {
        const compatible = variants.filter((variant) => (
          variant.options[changedIndex] === input.value
          && variant.options.slice(0, changedIndex).every((option, index) => option === chosen[index])
        ));
        match = compatible.find((variant) => variant.available) || compatible[0]
          || variants.find((variant) => variant.available && variant.options[changedIndex] === input.value)
          || variants.find((variant) => variant.options[changedIndex] === input.value)
          || null;
      }
      updateVariant(match);
    }, { signal }));

    productInfo.querySelectorAll('input[name="purchase_type"]').forEach((input) => input.addEventListener('change', () => {
      const group = input.closest('[data-selling-plans-for]');
      if (group) {
        preferredPurchaseType = input.value || input.dataset.purchaseOption || 'one_time';
        rememberPurchaseState();
        syncPurchaseState(group);
      }
    }, { signal }));
    productInfo.querySelectorAll('select[name="selling_plan"], [data-selling-plan-select]').forEach((select) => select.addEventListener('change', () => {
      const group = select.closest('[data-selling-plans-for]');
      if (group) {
        const selectedPlan = select.selectedOptions?.[0] || select.options?.[select.selectedIndex] || null;
        preferredSellingPlanId = String(selectedPlan?.value || '');
        preferredSellingPlanName = String(selectedPlan?.dataset.planName || selectedPlan?.textContent || '');
        syncPurchaseState(group);
      }
    }, { signal }));

    // Sticky purchase choices drive the authoritative purchase radios, so price,
    // cadence and the hidden selling_plan input stay in the existing sync path.
    productInfo.querySelectorAll('[data-sticky-purchase-option]').forEach((button) => button.addEventListener('click', () => {
      const group = sellingPlanGroups().find((candidate) => !candidate.hidden);
      if (!group) return;
      const targetValue = button.dataset.stickyPurchaseOption === 'subscription' ? 'subscription' : 'one_time';
      const option = group.querySelector(`input[name="purchase_type"][value="${targetValue}"]`);
      if (!option || option.disabled) return;
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal }));

    // Sticky frequency selector mirrors the authoritative plan select.
    productInfo.querySelectorAll('[data-sticky-selling-plan-select]').forEach((stickySelect) => stickySelect.addEventListener('change', () => {
      const group = sellingPlanGroups().find((candidate) => !candidate.hidden);
      const mainSelect = group?.querySelector('select[name="selling_plan"], [data-selling-plan-select]');
      if (!group || !mainSelect) return;
      mainSelect.value = stickySelect.value;
      mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal }));

    productInfo.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      if (!quantityInput) return;
      normalizeQuantity();
      const minimum = Number(quantityInput.min || 1);
      const increment = Number(quantityInput.step || 1);
      const direction = button.dataset.quantityChange === 'decrease' ? -1 : 1;
      const nextValue = Number(quantityInput.value || minimum) + (increment * direction);
      quantityInput.value = String(Math.max(minimum, nextValue));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal }));
    quantityInput?.addEventListener('change', normalizeQuantity, { signal });
    const syncStickyQuantity = () => {
      if (!quantityInput || !stickyQuantityInput) return;
      quantityInput.value = stickyQuantityInput.value;
      normalizeQuantity();
    };
    stickyQuantityInput?.addEventListener('input', () => {
      if (stickyQuantityInput.value !== '' && stickyQuantityInput.validity.valid) syncStickyQuantity();
    }, { signal });
    stickyQuantityInput?.addEventListener('change', syncStickyQuantity, { signal });


    if (activeVariant) updateVariant(activeVariant, { updateUrl: false });

    const sticky = productInfo.querySelector('[data-sticky-atc]');
    const mainAdd = productInfo.querySelector('[data-main-add-to-cart]');
    if (sticky && mainAdd) {
      const details = sticky.querySelector('[data-sticky-purchase-summary]');
      const edit = sticky.querySelector('[data-sticky-edit]');
      const panel = sticky.querySelector('[data-sticky-options-panel]');
      const close = sticky.querySelector('[data-sticky-edit-close]');
      const mobile = window.matchMedia('(max-width: 767px)');
      const quantity = sticky.querySelector('.fn-sticky-quantity');
      const action = sticky.querySelector('[data-sticky-add-to-cart]');
      let editorSelected = false;
      const syncPanel = () => {
        if (quantity && panel && action) {
          if (mobile.matches && quantity.parentElement !== panel) panel.append(quantity);
          else if (!mobile.matches && quantity.parentElement === panel) action.before(quantity);
        }
        const expanded = !details?.classList.contains('r-sticky-details--frequency-collapsed');
        if (panel) panel.inert = mobile.matches && !expanded;
        edit?.setAttribute('aria-expanded', String(expanded));
      };
      const setExpanded = (expanded) => {
        details?.classList.toggle('r-sticky-details--frequency-collapsed', !expanded);
        syncPanel();
      };
      edit?.addEventListener('click', () => setExpanded(edit.getAttribute('aria-expanded') !== 'true'), { signal });
      close?.addEventListener('click', () => { setExpanded(false); edit?.focus(); }, { signal });
      sticky.addEventListener('keydown', event => {
        if (event.key === 'Escape' && mobile.matches) { setExpanded(false); edit?.focus(); }
      }, { signal });
      const syncStickyVisibility = () => {
        // The reference reveals after the main purchase form has passed above.
        // Selecting the native sticky block reveals it for merchant editing.
        const visible = editorSelected || form.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.classList.toggle('sb-sticky-enabled', visible);
        sticky.classList.toggle('sb-sticky-atc--visible', visible);
        sticky.inert = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.dataset.mainCtaPassedAbove = String(form.getBoundingClientRect().bottom < 0);
        syncPanel();
        document.body.classList.toggle('fn-sticky-visible', visible);
        document.body.style.setProperty('--fn-sticky-height', visible ? `${sticky.offsetHeight}px` : '0px');
      };
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          if (sticky.classList.contains('is-visible')) document.body.style.setProperty('--fn-sticky-height', `${sticky.offsetHeight}px`);
        });
        resizeObserver.observe(sticky);
        productInfo.replicaStickyResizeObserver = resizeObserver;
      }
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.blockId !== sticky.dataset.stickyBlockId) return;
        editorSelected = true;
        syncStickyVisibility();
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (event.detail?.blockId !== sticky.dataset.stickyBlockId) return;
        editorSelected = false;
        syncStickyVisibility();
      }, { signal });
      window.addEventListener('scroll', syncStickyVisibility, { passive: true, signal });
      window.addEventListener('resize', syncStickyVisibility, { passive: true, signal });
      syncStickyVisibility();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(syncStickyVisibility, { threshold: 0 });
        productInfo.replicaProductObserver = observer;
        observer.observe(form);
      }
    }
  };

  const initializeProductInfos = (root = document) => collectProductInfos(root).forEach(initializeProductInfo);
  initializeProductInfos(document);
  document.addEventListener('shopify:section:load', (event) => initializeProductInfos(event.target));
  document.addEventListener('shopify:section:unload', (event) => collectProductInfos(event.target).forEach(cleanupProductInfo));

  const collectProductAccordions = (root = document) => {
    const containers = [];
    if (root?.matches?.('[data-product-accordions]')) containers.push(root);
    root?.querySelectorAll?.('[data-product-accordions]').forEach((container) => containers.push(container));
    return containers;
  };
  const cleanupProductAccordions = (container) => {
    container.replicaAccordionController?.abort();
    container.replicaAccordionController = null;
  };
  const initializeProductAccordions = (root = document) => collectProductAccordions(root).forEach((container) => {
    cleanupProductAccordions(container);
    const items = [...container.querySelectorAll('[data-product-accordion]')];
    if (!items.length) return;
    const controller = new AbortController();
    const { signal } = controller;
    container.replicaAccordionController = controller;
    const syncExpandedState = () => items.forEach((item) => {
      item.querySelector(':scope > summary')?.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    });
    items.forEach((item) => item.addEventListener('toggle', () => {
      if (item.open) items.forEach((other) => { if (other !== item) other.open = false; });
      syncExpandedState();
    }, { signal }));
    syncExpandedState();
  });
  initializeProductAccordions(document);
  document.addEventListener('shopify:section:load', (event) => initializeProductAccordions(event.target));
  document.addEventListener('shopify:section:unload', (event) => collectProductAccordions(event.target).forEach(cleanupProductAccordions));

  const replaceRenderedCart = (sectionHtml) => {
    if (!sectionHtml) return false;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextDrawer = parsed.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');
    if (!nextDrawer || !currentDrawer) return false;
    currentDrawer.replaceWith(nextDrawer);
    const nextCounts = [...parsed.querySelectorAll('[data-cart-count]')];
    document.querySelectorAll('[data-cart-count]').forEach((count, index) => {
      const nextCount = nextCounts[index] || nextCounts[0];
      if (!nextCount) return;
      count.textContent = nextCount.textContent;
      count.hidden = nextCount.hidden;
      const button = count.closest('[data-drawer-open="cart"]');
      if (button) button.setAttribute('aria-label', `Cart, ${nextCount.textContent.trim()} items`);
    });
    return true;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.replica-product-form, .replica-card-quick-add');
    if (!form) return;
    if (form.dataset.cartSubmitting === 'true') { event.preventDefault(); return; }
    const drawer = document.querySelector('#CartDrawer');
    const sectionId = drawer?.dataset.cartDrawerSection;
    if (!sectionId) return;
    event.preventDefault();
    form.dataset.cartSubmitting = 'true';
    const associatedButtons = form.id ? [...document.querySelectorAll(`[form="${CSS.escape(form.id)}"]`)] : [];
    const buttons = [...new Set([...form.querySelectorAll('[type="submit"]'), ...associatedButtons])];
    const disabledBefore = new Map(buttons.map(button => [button, button.disabled]));
    const stickyStatus = form.closest('.product__info-container')?.querySelector('[data-sticky-status]');
    if (stickyStatus) stickyStatus.textContent = '';
    buttons.forEach((button) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    let status = form.querySelector('[data-product-form-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'replica-product-form__status';
      status.setAttribute('data-product-form-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }
    status.textContent = '';
    try {
      const formData = new FormData(form);
      formData.append('sections', sectionId);
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item to your cart.');
      let sectionHtml = result.sections?.[sectionId];
      if (!sectionHtml) {
        const sectionResponse = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${encodeURIComponent(sectionId)}`, {
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (sectionResponse.ok) {
          const renderedSections = await sectionResponse.json();
          sectionHtml = renderedSections[sectionId];
        }
      }
      if (!replaceRenderedCart(sectionHtml)) window.location.assign('/cart');
      else openDrawer('cart', document.querySelector('[data-drawer-open="cart"]'));
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item to your cart.';
      if (stickyStatus) stickyStatus.textContent = status.textContent;
    } finally {
      form.dataset.cartSubmitting = 'false';
      buttons.forEach((button) => {
        button.disabled = button.dataset.variantAvailable === undefined
          ? disabledBefore.get(button)
          : button.dataset.variantAvailable !== 'true';
        button.removeAttribute('aria-busy');
      });
    }
  });
})();

// The guarantee stays in context; the link remains a usable no-JS fallback.
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-fn-guarantee-open]');
  if (opener) {
    const dialog = opener.closest('.shopify-section')?.querySelector('[data-fn-guarantee-dialog]');
    if (dialog) { event.preventDefault(); dialog.showModal(); }
  }
  const closer = event.target.closest('[data-fn-guarantee-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('[data-fn-guarantee-dialog]')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
